"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VeriffConfigOutSerializer = void 0;
exports.VeriffConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=veriffConfigOut.js.map